export default __webpack_public_path__ + "static/media/UBox.df6b3bba.jpg";